document.addEventListener('turbo:load', () => {
  const navbar = document.querySelector('.navbar-collapse-bootstrap')
  if (!navbar) return

  const keepMobileNavVisible = () => {
    navbar.querySelectorAll('.mobile-account, .navbar-item').forEach(item => item.classList.remove('d-none'))
  }

  navbar.querySelectorAll('.navbar-dropdown, .navbar-item').forEach(el => {
    el.addEventListener('click', keepMobileNavVisible)
  })
})